import './network'

console.log('%c😁 ', 'font-size: 48px;')
console.log('%cCurious? ', 'font-size: 24px; font-weight: bold; color: "purple";')
console.log('%cNeed a developer/designer?', 'font-size: 16px; font-weight: bold;')
console.log('%cYou‘re in the right place!', 'font-size: 16px; font-weight: bold;')

// ─── Lang query param ────────────────────────────────────────────────────────

const params = new URLSearchParams(location.search)
const lang = params.get('lang')

if (lang) {
  localStorage.setItem('lang', lang)
  document.documentElement.lang = lang
  document.documentElement.className = document.documentElement.className.replace(/\blang-\w+/g, '') + ' lang-' + lang
}

function $qa(selector, parent = document) {
  return Array.from(parent.querySelectorAll(selector))
}

function $q(selector, parent = document) {
  return parent.querySelector(selector)
}

function addClass(element, className) {
  if (element) {
    element.classList.add(className)
  }
}

function removeClass(element, className) {
  if (element) {
    element.classList.remove(className)
  }
}

function containsClass(element, className) {
  if (element) {
    return element.classList.contains(className)
  }

  return false
}

$qa('.reference').forEach(($el, i) => {
  $el.style.transitionDelay = (i * 0.1) + 's'
})

$qa('.awards-container p span').forEach(($el, i) => {
  $el.style.transitionDelay = (i * 0.1) + 's'
})

$qa('.clients-container img').forEach(($el, i) => {
  $el.style.transitionDelay = 3.5 + (i * 0.1) + 's'
})

// ─────────────────────────────────────────────────────────────────────────────

const isMobile = () => /(Android|webOS|Phone|iPad|iPod|BlackBerry|Windows Phone)/i.test(navigator.userAgent)

const debounce = (fn, delay) => {
  let last
  let timer

  return function (...args) {
    const now = Date.now()

    if (last && now < last + delay) {
      clearTimeout(timer)

      timer = setTimeout(() => {
        last = now
        fn(...args)
      }, delay)

      return timer
    } else {
      last = now

      return fn(...args)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const slideContainer = $q('.slide-container')
  const pageContainer = $q('.work-container')
  const pageNavigation = $q('.work-pagination')
  const totalWorks = $qa('.work').length
  const references = $q('.references')
  const referencesWrapper = $q('.references-wrapper')
  const referenceNavigation = $q('.reference-pagination')
  const referenceCards = $qa('.reference', referencesWrapper || document)
  const animationEnd = 'animationend'
  const angle = { cube: 0 }
  const face = { cube: 0 }

  let totalPages = totalWorks
  let page = 1
  let totalReferencePages = referenceCards.length
  let referencePage = 1

  // ─── Cube 3D ────────────────────────────────────────────────────────────

  const rotateCube = (type) => {
    angle[type] += 90
    face[type] += 1

    if (face[type] >= 4) {
      face[type] = 0
    }

    const cubeFaces = $qa('.' + type + ' div')

    cubeFaces.forEach((faceElement) => {
      removeClass(faceElement, 'active')
    })

    if (cubeFaces[face[type]]) {
      addClass(cubeFaces[face[type]], 'active')
    }

    const cube = $q('.' + type)

    if (cube) {
      cube.style.transform = 'rotateX(' + angle[type] + 'deg)'
    }

    setTimeout(
      () => {
        rotateCube(type)
      },
      Math.random() * 1000 + 1000
    )
  }

  rotateCube('cube')

  if (references && referencesWrapper && !isMobile()) {
    let tiltFrame = null
    let isOverReferencesLink = false
    let targetRotateX = 0
    let targetRotateY = 0
    let currentRotateX = 0
    let currentRotateY = 0

    const renderTilt = () => {
      currentRotateX += (targetRotateX - currentRotateX) * 0.12
      currentRotateY += (targetRotateY - currentRotateY) * 0.12

      referencesWrapper.style.setProperty('--tilt-x', currentRotateX.toFixed(2) + 'deg')
      referencesWrapper.style.setProperty('--tilt-y', currentRotateY.toFixed(2) + 'deg')

      const stillAnimating =
        Math.abs(targetRotateX - currentRotateX) > 0.01 ||
        Math.abs(targetRotateY - currentRotateY) > 0.01

      if (stillAnimating) {
        tiltFrame = requestAnimationFrame(renderTilt)
      } else {
        tiltFrame = null
      }
    }

    const queueTiltRender = () => {
      if (!tiltFrame) {
        tiltFrame = requestAnimationFrame(renderTilt)
      }
    }

    const resetTiltImmediately = () => {
      targetRotateX = 0
      targetRotateY = 0
      currentRotateX = 0
      currentRotateY = 0

      if (tiltFrame) {
        cancelAnimationFrame(tiltFrame)
        tiltFrame = null
      }

      referencesWrapper.style.setProperty('--tilt-x', '0deg')
      referencesWrapper.style.setProperty('--tilt-y', '0deg')
    }

    references.addEventListener('mouseover', (event) => {
      const link = event.target.closest('a')

      if (!link) {
        return
      }

      isOverReferencesLink = true
      resetTiltImmediately()
    })

    references.addEventListener('mouseout', (event) => {
      const link = event.target.closest('a')

      if (!link) {
        return
      }

      const to = event.relatedTarget

      if (to && link.contains(to)) {
        return
      }

      isOverReferencesLink = false
    })

    references.addEventListener('mousemove', (event) => {
      if (isOverReferencesLink || event.target.closest('a')) {
        resetTiltImmediately()

        return
      }

      const rect = references.getBoundingClientRect()
      const x = (event.clientX - rect.left) / rect.width
      const y = (event.clientY - rect.top) / rect.height

      const rotateY = (x - 0.5) * 3
      const rotateX = (0.5 - y) * 2.25

      targetRotateX = rotateX
      targetRotateY = rotateY
      queueTiltRender()
    })

    references.addEventListener('mouseleave', () => {
      targetRotateX = 0
      targetRotateY = 0
      queueTiltRender()
    })
  }

  // ─── Scroll vers un slide (1-based) ────────────────────────────────────

  const scrollToSlide = (idx) => {
    if (!slideContainer) {
      return
    }

    const target = $qa('.slide', slideContainer)[idx - 1]

    if (!target) {
      return
    }
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'

    slideContainer.scrollTo({
      top: target.getBoundingClientRect().top - slideContainer.getBoundingClientRect().top + slideContainer.scrollTop,
      behavior
    })
  }

  // ─── Détection du slide visible ─────────────────────────────────────────

  let swipeTimer
  let swipeTimer2
  let hint1shown = false
  let hint2shown = false

  const slideObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= .6) {
          document.documentElement.dataset.backgroundSection = entry.target.id
        }

        if (containsClass(entry.target, 'works')) {
          if (entry.isIntersecting) {
            addClass(document.documentElement, 'works-visible')
          } else {
            removeClass(document.documentElement, 'works-visible')
          }
        }

        if (containsClass(entry.target, 'references')) {
          if (entry.isIntersecting) {
            addClass(document.documentElement, 'references-visible')
          } else {
            removeClass(document.documentElement, 'references-visible')
          }
        }

        if (entry.isIntersecting) {
          if (containsClass(entry.target, 'contributions')) {
            addClass(entry.target, 'animated')
          }

          if (containsClass(entry.target, 'references')) {
            addClass(entry.target, 'animated')
          }

          if (containsClass(entry.target, 'hero') && !hint1shown) {
            hint1shown = true

            swipeTimer = setTimeout(() => {
              $qa('.touch .slide-swipe').forEach((element) => {
                addClass(element, 'vertical')
              })

              $qa('.slide-swipe .icon').forEach((icon) => {
                icon.addEventListener(
                  animationEnd,
                  () => {
                    $qa('.slide-swipe').forEach((element) => {
                      removeClass(element, 'vertical')
                    })
                  },
                  { once: true }
                )
              })
            }, 4000)
          }

          if (containsClass(entry.target, 'works') && !hint2shown) {
            hint2shown = true

            swipeTimer2 = setTimeout(() => {
              $qa('.touch .slide-swipe').forEach((element) => {
                addClass(element, 'horizontal')
              })

              $qa('.slide-swipe .icon').forEach((icon) => {
                icon.addEventListener(
                  animationEnd,
                  () => {
                    $qa('.slide-swipe').forEach((element) => {
                      removeClass(element, 'horizontal')
                    })
                  },
                  { once: true }
                )
              })
            }, 600)
          }
        } else {
          if (containsClass(entry.target, 'hero')) {
            clearTimeout(swipeTimer)

            $qa('.slide-swipe').forEach((element) => {
              removeClass(element, 'vertical')
            })
          }

          if (containsClass(entry.target, 'works')) {
            clearTimeout(swipeTimer2)

            $qa('.slide-swipe').forEach((element) => {
              removeClass(element, 'horizontal')
            })
          }
        }
      })
    },
    {
      root: slideContainer,
      threshold: 0.6
    }
  )

  $qa('.slide').forEach((slide) => {
    slideObserver.observe(slide)
  })

  // ─── Navigation Works (horizontal) ─────────────────────────────────────

  const gotoPage = (idx) => {
    page = idx

    const firstWork = $q('.work')

    if (!firstWork || !pageContainer) {
      return
    }

    const width = firstWork.offsetWidth

    pageContainer.scrollTo({
      left: (page - 1) * width,
      behavior: 'smooth'
    })

    const works = $qa('.work', pageContainer)

    works.forEach((work) => {
      removeClass(work, 'active')
    })

    if (works[page - 1]) {
      addClass(works[page - 1], 'active')
    }

    updatePageNavigation()
  }

  const nextPage = () => {
    if (page >= totalPages) {
      return
    }

    page += 1
    gotoPage(page)
  }

  const previousPage = () => {
    if (page <= 1) {
      return
    }

    page -= 1
    gotoPage(page)
  }

  const changePage = (e) => {
    if (e.keyCode === 37) {
      e.preventDefault()
      previousPage()
    }

    if (e.keyCode === 39) {
      e.preventDefault()
      nextPage()
    }
  }

  if (pageContainer) {
    pageContainer.addEventListener('scrollend', () => {
      const firstWork = $q('.work', pageContainer)

      if (!firstWork) {
        return
      }

      const workWidth = firstWork.offsetWidth
      const newPage = Math.round(pageContainer.scrollLeft / workWidth) + 1
      const works = $qa('.work', pageContainer)

      page = Math.max(1, Math.min(newPage, totalPages))

      works.forEach((work) => {
        removeClass(work, 'active')
      })

      if (works[page - 1]) {
        addClass(works[page - 1], 'active')
      }

      updatePageNavigation()
    })
  }

  const updatePageNavigation = () => {
    if (!pageNavigation) {
      return
    }

    const paginationLinks = $qa('a', pageNavigation)
    const previousButton = $q('.work-previous')
    const nextButton = $q('.work-next')

    paginationLinks.forEach((link) => {
      removeClass(link, 'active')
    })

    if (paginationLinks[page - 1]) {
      addClass(paginationLinks[page - 1], 'active')
    }

    if (previousButton) {
      removeClass(previousButton, 'disabled')

      if (page === 1) {
        addClass(previousButton, 'disabled')
      }
    }

    if (nextButton) {
      removeClass(nextButton, 'disabled')

      if (page === totalPages) {
        addClass(nextButton, 'disabled')
      }
    }
  }

  const isReferencesMobileSnap = () => window.matchMedia('(max-width: 1000px)').matches

  const updateReferenceNavigation = () => {
    if (!referenceNavigation || !isReferencesMobileSnap()) {
      return
    }

    const paginationLinks = $qa('a', referenceNavigation)

    paginationLinks.forEach((link) => {
      removeClass(link, 'active')
    })

    if (paginationLinks[referencePage - 1]) {
      addClass(paginationLinks[referencePage - 1], 'active')
    }
  }

  const getReferencePageFromScroll = () => {
    if (!referencesWrapper || referenceCards.length === 0) {
      return 1
    }

    const currentLeft = referencesWrapper.scrollLeft
    let closestIndex = 0
    let closestDistance = Number.POSITIVE_INFINITY

    referenceCards.forEach((card, index) => {
      const distance = Math.abs(card.offsetLeft - currentLeft)

      if (distance < closestDistance) {
        closestDistance = distance
        closestIndex = index
      }
    })

    return closestIndex + 1
  }

  const gotoReferencePage = (idx) => {
    referencePage = idx

    if (!referencesWrapper || !referenceCards[referencePage - 1]) {
      return
    }

    referencesWrapper.scrollTo({
      left: referenceCards[referencePage - 1].offsetLeft,
      behavior: 'smooth'
    })

    updateReferenceNavigation()
  }

  const initReferencesPagination = () => {
    if (!referenceNavigation) {
      return
    }

    referenceNavigation.innerHTML = ''
    totalReferencePages = referenceCards.length
    referencePage = Math.max(1, Math.min(referencePage, totalReferencePages || 1))

    if (!isReferencesMobileSnap() || totalReferencePages <= 1) {
      return
    }

    for (let x = 0; x < totalReferencePages; x += 1) {
      const link = document.createElement('a')

      link.href = '#'
      link.addEventListener('click', (e) => {
        const links = $qa('a', referenceNavigation)

        e.preventDefault()
        gotoReferencePage(Array.from(links).indexOf(e.currentTarget) + 1)
      })

      referenceNavigation.appendChild(link)
    }

    referencePage = getReferencePageFromScroll()
    updateReferenceNavigation()
  }

  const orientation = () => {
    const orientationAngle = screen.orientation ? screen.orientation.angle : 0
    const swipeHints = $qa('.touch .slide-swipe')

    if (isMobile() && orientationAngle % 180 !== 0) {
      swipeHints.forEach((element) => {
        addClass(element, 'orientation')
      })
    } else {
      swipeHints.forEach((element) => {
        removeClass(element, 'orientation')
      })
    }
  }

  const initWorks = () => {
    const workElement = $q('.work')

    updatePageNavigation()

    if (!workElement || !pageNavigation) {
      totalPages = 0

      return
    }

    const workWidth = workElement.getBoundingClientRect().width
    const containerWidth = pageContainer ? pageContainer.clientWidth : window.innerWidth
    const worksPerPage = Math.max(1, Math.floor(containerWidth / workWidth))

    totalPages = Math.ceil(totalWorks / worksPerPage)
    pageNavigation.innerHTML = ''

    if (totalPages <= 1) {
      return
    }

    for (let x = 0; x < totalPages; x += 1) {
      const link = document.createElement('a')

      link.href = '#'
      link.addEventListener('click', (e) => {
        const links = $qa('a', pageNavigation)

        e.preventDefault()
        gotoPage(Array.from(links).indexOf(e.currentTarget) + 1)
      })
      pageNavigation.appendChild(link)
    }

    updatePageNavigation()

    if (page > totalPages) {
      page = totalPages
      gotoPage(page)
    }
  }

  // ─── Init ────────────────────────────────────────────────────────────────

  initWorks()
  gotoPage(page)
  initReferencesPagination()

  if ('ontouchstart' in window || 'onmsgesturechange' in window) {
    document.documentElement.classList.add('touch')
  } else {
    document.documentElement.classList.add('no-touch')
  }

  const wrapTextNodes = (root) => {
    Array.from(root.childNodes).forEach((node) => {
      if (node.nodeType === 3) {
        const wrapper = document.createElement('span')

        node.parentNode.insertBefore(wrapper, node)
        wrapper.appendChild(node)
      }
    })
  }

  $qa('.hero-bio p').forEach((paragraph) => {
    wrapTextNodes(paragraph)
  })

  const contributionsParagraph = $q('.contributions p')

  if (contributionsParagraph) {
    wrapTextNodes(contributionsParagraph)
  }

  $qa('.lang-btn').forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()

      const selectedLang = e.currentTarget.getAttribute('data-lang')

      document.documentElement.lang = selectedLang
      document.documentElement.className = document.documentElement.className.replace(/\blang-\w+/g, '') + ' lang-' + selectedLang
      localStorage.setItem('lang', selectedLang)

      const url = new URL(location.href)

      url.searchParams.set('lang', selectedLang)
      history.replaceState(null, '', url)
      restartBubble(selectedLang)
    })
  })

  $qa('.social-email a').forEach((link) => {
    link.setAttribute('href', 'mailto:' + link.getAttribute('href').replace('#', '@').replace('|', '.'))
  })

  $qa('.hero-scroll').forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      scrollToSlide(2)
    })
  })

  $qa('.work-previous').forEach((button) => {
    button.addEventListener('click', (e) => {
      previousPage()
      e.preventDefault()
    })
  })

  $qa('.work-next').forEach((button) => {
    button.addEventListener('click', (e) => {
      nextPage()
      e.preventDefault()
    })
  })

  if (referencesWrapper) {
    const syncReferencePagination = debounce(() => {
      if (!isReferencesMobileSnap() || totalReferencePages <= 1) {
        return
      }

      referencePage = getReferencePageFromScroll()
      updateReferenceNavigation()
    }, 50)

    referencesWrapper.addEventListener('scroll', syncReferencePagination)
    referencesWrapper.addEventListener('scrollend', syncReferencePagination)
  }

  setTimeout(() => {
    $qa('.hero').forEach((hero) => {
      hero.classList.add('animated')
    })
  }, 500)

  window.addEventListener('keydown', debounce(changePage, 50))
  window.addEventListener('resize', debounce(() => {
    initWorks()
    initReferencesPagination()
  }, 250))
  window.addEventListener('orientationchange', orientation)
  window.dispatchEvent(new Event('orientationchange'))
})

// ─── Typing FX ───────────────────────────────────────────────────────────────

const container = document.querySelector('.bubble-text')
const sentences = []
const allSentences = []

let typingGen = 0

$qa('.bubble-text p').forEach((item) => {
  allSentences.push({
    text: item.innerHTML,
    wait: item.dataset.wait,
    back: item.dataset.back,
    lang: item.getAttribute('lang')
  })
})

const collectSentences = (activeLang) => {
  sentences.length = 0
  allSentences.forEach((sentence) => {
    if (!sentence.lang || sentence.lang === activeLang) {
      sentences.push(sentence)
    }
  })
}

const restartBubble = (activeLang) => {
  typingGen += 1
  const gen = typingGen

  collectSentences(activeLang)

  if (!container) {
    return
  }

  container.innerHTML = ''

  $qa('.bubble').forEach((bubble) => {
    bubble.classList.add('shown')
  })

  typing(0, gen)
}

collectSentences(document.documentElement.lang)
if (container) {
  container.innerHTML = ''
}

setTimeout(() => {
  typing(0, typingGen)
}, 2000)

const typing = (i, gen) => {
  if (gen !== typingGen || !container) {
    return
  }

  if (!sentences[i]) {
    $qa('.bubble').forEach((bubble) => {
      bubble.classList.remove('shown')
    })

    return
  }

  const sentence = sentences[i]
  const text = sentence.text + '_'

  forward(
    text,
    0,
    () => {
      typing(i + 1, gen)
    },
    sentence.wait,
    sentence.back,
    gen
  )
}

const forward = (text, x, done, wait, back, gen) => {
  if (gen !== typingGen || !container) {
    return
  }

  let blinking = ''
  const nextX = x + 1

  if (nextX === text.length) {
    blinking = 'bubble-blinking'
  }

  const part = text.substring(0, nextX)
  const parts =
    '> ' +
    part.substring(0, nextX - 1) +
    '<span class="bubble-cursor ' +
    blinking +
    '">' +
    part.substring(nextX - 1, nextX) +
    '</span>'

  container.innerHTML = parts

  if (nextX < text.length) {
    setTimeout(
      () => {
        forward(text, nextX, done, wait, back, gen)
      },
      Math.random() * 70 + 10
    )
  } else {
    setTimeout(() => {
      if (back) {
        backward(text, nextX, done, gen)
      } else {
        done()
      }
    }, wait)
  }
}

const backward = (text, x, done, gen) => {
  if (gen !== typingGen || !container) {
    return
  }

  const nextX = x - 1

  container.innerHTML = '> ' + text.substring(0, nextX) + '<span class="bubble-cursor">_</span>'

  if (nextX !== 0) {
    setTimeout(() => {
      backward(text, nextX, done, gen)
    }, Math.random() * 40)
  } else {
    done()
  }
}

// ────────────────────────────────────────────────────────────────────────────

const $cursor = document.querySelector('#cursor')

if ($cursor) {
  let cursorX = 0
  let cursorY = 0
  let cursorFrame = null
  let hoverState = false
  let lastTouchAt = 0

  const clearHover = () => {
    $cursor.classList.remove('hover')
    hoverState = false
  }

  const renderCursor = () => {
    $cursor.style.left = `${cursorX}px`
    $cursor.style.top = `${cursorY}px`

    const hovered = document.elementFromPoint(cursorX, cursorY)
    const isOverLink = !!(hovered && hovered.closest('a'))

    if (isOverLink !== hoverState) {
      $cursor.classList.toggle('hover', isOverLink)
      hoverState = isOverLink
    }

    cursorFrame = null
  }

  window.addEventListener('mousemove', (e) => {
    if (Date.now() - lastTouchAt < 500) {
      return
    }

    cursorX = e.clientX
    cursorY = e.clientY

    if (!cursorFrame) {
      cursorFrame = requestAnimationFrame(renderCursor)
    }
  })

  ;[ 'touchstart', 'touchend', 'touchcancel' ].forEach((event) => {
    window.addEventListener(event, () => {
      lastTouchAt = Date.now()
      clearHover()
    })
  })

  window.addEventListener('mouseleave', clearHover)
}
